import type { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { useSession } from '../../auth';
import { AccessDenied } from './AccessDenied';
import { AdminNotFound } from './AdminNotFound';
import { AdminShell } from './AdminShell';
import { BitrixScreen } from './BitrixScreen';
import { QuickRepliesScreen } from './QuickRepliesScreen';
import { USERS_PATH } from './paths';
import { UsersScreen } from './UsersScreen';
import { WhatsAppScreen } from './WhatsAppScreen';

/**
 * Área de administração (`/admin/*`): usuários, WhatsApp (conexão e números), respostas rápidas e Bitrix.
 *
 * A guarda fica AQUI, antes de qualquer tela que busque dados: um atendente vê "Acesso negado" e
 * nenhuma rota `/admin/*` da API é chamada. (O servidor também responde 403; esta checagem evita o
 * pedido inútil e explica à pessoa o que houve.) O papel vem da sessão, que a casca de autenticação
 * mantém em dia: se ele mudar com a tela aberta, a tela acompanha.
 */
export function AdminPage(): ReactElement | null {
  const session = useSession();
  // `RequireAuth` só deixa passar quem está conectado; isto estreita o tipo.
  if (session.status !== 'authenticated') return null;
  if (session.user.role !== 'admin') return <AccessDenied />;

  return (
    <AdminShell>
      <Routes>
        <Route index element={<Navigate to={USERS_PATH} replace />} />
        <Route path="usuarios" element={<UsersScreen viewerId={session.user.id} />} />
        <Route path="whatsapp" element={<WhatsAppScreen />} />
        <Route path="respostas-rapidas" element={<QuickRepliesScreen />} />
        <Route path="bitrix" element={<BitrixScreen />} />
        <Route path="*" element={<AdminNotFound />} />
      </Routes>
    </AdminShell>
  );
}
